import React from "react";
const Footer = () => (
    <div class="footer">
        <span class="copyright">
            &copy; <span class="primary">Liquid</span>Metrix | All Rights
            Reserved
        </span>
    </div>
);

export default Footer;
